import React, { ReactElement, RefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { fadeAnimationCss, scrollbar } from '../../styles/GlobalStyle';
import { useDebounceFunc } from '../../hooks/useDebounceFunc';

interface ScrollableListProps {
  children: React.ReactNode;
  height: CSSSize | 'auto';
  autoScroll?: boolean;
  onScrolledToBottom?: () => void; // TODO rename
  className?: string;
}

function ScrollableList({
  children,
  height,
  onScrolledToBottom,
  autoScroll,
  className,
}: ScrollableListProps): ReactElement {
  const debouncedFunc = useDebounceFunc(400);
  const divRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (divRef.current && autoScroll) {
      divRef.current?.scrollTo(0, divRef.current?.scrollHeight);
    }
  }, [divRef.current?.scrollHeight]);

  const scrollHandler = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target: HTMLDivElement = event.target as HTMLDivElement;
    if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 32) {
      debouncedFunc(() => {
        onScrolledToBottom && onScrolledToBottom();
      });
    }
  };

  return (
    <Scrollable ref={divRef} height={height} onScroll={scrollHandler} className={className}>
      {children}
    </Scrollable>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Scrollable = styled.div<{ ref?: any; height: CSSSize | 'auto' }>`
  height: ${props => props.height};
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  ${scrollbar};
  ${fadeAnimationCss}
`;

export { ScrollableList };
